import { createContext } from "react";

/**
 * Navigation context which provides context to navigation cards what context they're within.
 */
export const NavContext = createContext<"dashboard" | "drawer" | null>(null);
